var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"activity-header"},[_c('button',{staticClass:"header-back",attrs:{"type":"button","aria-label":"返回"},on:{"click":function($event){return _vm.$emit('back')}}},[_c('span')]),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"header-actions"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }